import { render, staticRenderFns } from "./ModalLightbox.vue?vue&type=template&id=70f70565&scoped=true"
import script from "./ModalLightbox.vue?vue&type=script&lang=js"
export * from "./ModalLightbox.vue?vue&type=script&lang=js"
import style0 from "./ModalLightbox.vue?vue&type=style&index=0&id=70f70565&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f70565",
  null
  
)

export default component.exports